import { createHashRouter } from 'react-router-dom';

import App from './App';
import { accountingRoutes } from './page-routes/AccountingRoutes';
import { inventories } from './page-routes/InventoryRoutes';
import { revenueAndCollectionRoutes } from './page-routes/RevenueAndCollectionRoutes';
import { Transactions } from './pages/Accounting/Transactions';
import { DashBoard } from './pages/Dashboard/Dashboard';
import { Home } from './pages/Home';
import { Bills } from './pages/Purchase/Bills';
import { PaymentsSetup } from './pages/Purchase/PaymentsSetUp';
import { ProductsAndServicesonPurchase } from './pages/Purchase/ProductsAndServices';
import { Vendor } from './pages/Purchase/Vendor';
import { AgedReceivables } from './pages/Reports/AgedReceivables';
import { IncomeByCategory } from './pages/Reports/IncomeByCategory';
import { IncomeByCustomer } from './pages/Reports/IncomeByCustomer';
import { Reports } from './pages/Reports/Reports';
import { SalesTaxReport } from './pages/Reports/SalesTaxReport';
import {
  SalesTax,
  SalesTaxCreate,
  SalesTaxEdit,
  SalesTaxList,
} from './pages/Setup/SalesTax';

import AuthLogoutPage from 'src/auth/components/AuthLogoutPage';
import RequireAuth from 'src/auth/components/RequireAuth';
import WorkspaceSelectorPage from 'src/auth/components/WorkspaceSelectorPage';
import { settingsRoutes } from 'src/modules/settings/SettingsRoutes';

const reports = {
  path: 'reports',
  element: <Reports />,
  children: [
    { path: 'aged-receivables', element: <AgedReceivables /> },
    { path: 'income-by-customer', element: <IncomeByCustomer /> },
    { path: 'sales-tax-report', element: <SalesTaxReport /> },
    { path: 'income-by-category', element: <IncomeByCategory /> },
  ],
};

const salesTaxSettings = {
  path: 'settings/sales-taxes',
  element: <SalesTax />,
  children: [
    { index: true, element: <SalesTaxList /> },
    { path: 'create', element: <SalesTaxCreate /> },
    { path: ':id/edit', element: <SalesTaxEdit /> },
  ],
};

export const AppRouter = createHashRouter([
  { path: '/auth/workspace-select', element: <WorkspaceSelectorPage /> },
  { path: '/auth/logout', element: <AuthLogoutPage /> },
  {
    path: '/',
    element: <RequireAuth />,
    children: [
      {
        path: '/',
        element: <App />,
        children: [
          { index: true, element: <Home /> },
          { path: 'dashboard', element: <DashBoard /> },
          revenueAndCollectionRoutes,
          inventories,
          salesTaxSettings,
          settingsRoutes,
          accountingRoutes,
          reports,
          {
            path: 'purchase-and-payments/bills',
            element: <Bills />,
          },
          {
            path: 'purchase-and-payments/payment-set-up',
            element: <PaymentsSetup />,
          },
          { path: 'purchase-and-payments/vendors', element: <Vendor /> },
          {
            path: 'purchase-and-payments/products-and-services',
            element: <ProductsAndServicesonPurchase />,
          },
          { path: 'accounting/transactions', element: <Transactions /> },
        ],
      },
    ],
  },
]);
